module.exports = __webpack_public_path__ + "img/cognitive_img08.a9d09fe2.png";